import React from "react";
import { resolveScheduleStatusName } from "../../utils/scheduleStatuses";
import "../../styles/scheduleTable.css";

function statusClass(name) {
  const n = String(name).toLowerCase();
  if (n === "pending") return "schedule-status--pending";
  if (n === "upcoming") return "schedule-status--upcoming";
  if (n === "completed") return "schedule-status--completed";
  if (n === "cancelled") return "schedule-status--cancelled";
  return "schedule-status--pending";
}

export default function ScheduleStatusBadge({ schedule }) {
  const name = resolveScheduleStatusName(schedule) || "—";
  return <span className={`schedule-status-tag ${statusClass(name)}`}>{name}</span>;
}
